// extracted by mini-css-extract-plugin
export default {"header":"Header-module__header___Pa_DT","headerSpacer":"Header-module__headerSpacer___zw8_O"};